// extracted by mini-css-extract-plugin
export default {"main-header":"UpdatedSearchResultPage_main-header__5Qk5z","animate-top":"UpdatedSearchResultPage_animate-top__nj1+G"};